export const DELIVERY_NOTE_ASSIGNMENT_SOURCE = [
  'manual_link',
  'article_number',
  'suggestion',
] as const;

export const DELIVERY_NOTE_ASSIGNMENT_REASON = [
  'similar_name',
  'same_unit',
] as const;

export const DELIVERY_NOTE_ASSIGNMENT_MAX_DELIVERY_NOTES = 250;
